import React, {FC} from 'react';

import {PageTitle} from 'components';
import {useTranslation} from 'react-i18next';
import Game from './Game/Game';

const Playground: FC = () => {
  const {t} = useTranslation();
  return (
    <div className="page animation-scale-up">
      <PageTitle title={t('playgroundTitle')} />
      <Game />
    </div>
  );
};

export default Playground;
